import { DemoNamedPath } from "src/util/enums/namedPaths"
import { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw = {
  path: "/ui-demo",
  component: () => import("src/layouts/DemoLayout.vue"),
  children: [
    {
      path: "",
      name: DemoNamedPath.UI_DEMO,
      component: () => null,
      beforeEnter: () => {
        return { name: DemoNamedPath.DEMO_INDEX }
      },
    },
    {
      path: "home",
      name: DemoNamedPath.DEMO_INDEX,
      component: () => import("src/pages/demo/DemoIndex.vue"),
    },
    {
      path: "store",
      name: DemoNamedPath.EXAMPLE_STORE,
      component: () => import("src/pages/demo/functionality/ExampleStore.vue"),
    },
    {
      path: "database",
      name: DemoNamedPath.DATABASE,
      component: () => import("src/pages/demo/functionality/DatabaseExample.vue"),
    },
    {
      path: "barcode-reader",
      name: DemoNamedPath.BARCODE_READER,
      component: () => import("src/pages/demo/functionality/BarcodeReader.vue"),
    },
    {
      path: "keyboard-reader",
      name: DemoNamedPath.KEYBOARD_READER,
      component: () => import("src/pages/demo/functionality/KeyboardReader.vue"),
    },
    {
      path: "nfc-reader",
      name: DemoNamedPath.NFC_READER,
      component: () => import("src/pages/demo/functionality/NfcReader.vue"),
    },
    {
      path: "api-calls",
      name: DemoNamedPath.API_CALLS,
      component: () => import("src/pages/demo/functionality/ApiCalls.vue"),
    },
    {
      path: "custom-directives",
      name: DemoNamedPath.CUSTOM_DIRECTIVES,
      component: () => import("src/pages/demo/functionality/CustomDirectives.vue"),
    },
    {
      path: "general-directives",
      name: DemoNamedPath.GENERAL_DIRECTIVES,
      component: () => import("src/pages/demo/elements/GeneralDirectives.vue"),
    },
    {
      path: "typography",
      name: DemoNamedPath.TYPOGRAPHY,
      component: () => import("src/pages/demo/elements/TypographyElements.vue"),
    },
    {
      path: "cards",
      name: DemoNamedPath.CARDS,
      component: () => import("src/pages/demo/elements/CardElements.vue"),
    },
    {
      path: "dialogs-and-overlays",
      name: DemoNamedPath.DIALOGS_AND_OVERLAYS,
      component: () => import("src/pages/demo/elements/DialogsAndOverlays.vue"),
    },
    {
      path: "custom-icons",
      name: DemoNamedPath.CUSTOM_ICONS,
      component: () => import("src/pages/demo/elements/CustomIcons.vue"),
    },
    {
      path: "button-elements",
      name: DemoNamedPath.BUTTONS,
      component: () => import("src/pages/demo/elements/ButtonsElements.vue"),
    },
    {
      path: "input-elements",
      name: DemoNamedPath.INPUTS,
      component: () => import("src/pages/demo/elements/InputFields.vue"),
    },
    {
      path: "issue-elements",
      name: DemoNamedPath.ISSUES,
      component: () => import("src/pages/demo/elements/IssueElements.vue"),
    },
    {
      path: "select-elements",
      name: DemoNamedPath.SELECTS,
      component: () => import("src/pages/demo/elements/SelectFields.vue"),
    },
    {
      path: "table-elements",
      name: DemoNamedPath.TABLE,
      component: () => import("src/pages/demo/elements/TableElements.vue"),
    },
    {
      path: "tab-elements",
      name: DemoNamedPath.TABS,
      component: () => import("src/pages/demo/elements/TabElements.vue"),
    },
    {
      path: "special-purpose",
      name: DemoNamedPath.SPECIAL_PURPOSE,
      component: () => import("src/pages/demo/elements/SpecialPurpose.vue"),
    },
    {
      path: "top-navigation",
      name: DemoNamedPath.TOP_NAVIGATION,
      component: () => import("src/pages/demo/elements/TopNavigation.vue"),
    },
    {
      path: "radio-buttons",
      name: DemoNamedPath.RADIO_BUTTONS,
      component: () => import("src/pages/demo/elements/RadioButtons.vue"),
    },
    {
      path: "empty-states",
      name: DemoNamedPath.EMPTY_STATES,
      component: () => import("src/pages/demo/elements/EmptyStates.vue"),
    },
    {
      path: "progress-indicator",
      name: DemoNamedPath.PROGRESS_INDICATOR,
      component: () => import("src/pages/demo/elements/ProgressIndicator.vue"),
    },
    {
      path: "data-point",
      name: DemoNamedPath.DATA_POINT,
      component: () => import("src/pages/demo/elements/DataPoint.vue"),
    },
    {
      path: "chips",
      name: DemoNamedPath.CHIPS,
      component: () => import("src/pages/demo/elements/ChipElements.vue"),
    },
    {
      path: "main-menu",
      name: DemoNamedPath.MAIN_MENU,
      component: () => import("src/pages/demo/elements/MainMenu.vue"),
    },
    {
      path: "to-do",
      name: DemoNamedPath.TO_DO,
      component: () => import("src/pages/demo/elements/ToDoElements.vue"),
    },
    {
      path: "toggle-elements",
      name: DemoNamedPath.TOGGLE,
      component: () => import("src/pages/demo/elements/ToggleElements.vue"),
    },
    {
      path: "procedure-step",
      name: DemoNamedPath.PROCEDURE_STEP,
      component: () => import("src/pages/demo/elements/ProcedureSteps.vue"),
    },
    {
      path: "search-bar",
      name: DemoNamedPath.SEARCH_BAR,
      component: () => import("src/pages/demo/functionality/SearchBar.vue"),
    },
    {
      path: "notifications",
      name: DemoNamedPath.NOTIFICATIONS,
      component: () => import("src/pages/demo/elements/NotificationMessages.vue"),
    },
    {
      path: "priority-labels",
      name: DemoNamedPath.PRIORITY_LABELS,
      component: () => import("src/pages/demo/elements/PriorityLabels.vue"),
    },
    {
      path: "filtering",
      name: DemoNamedPath.FILTERING_ELEMENTS,
      component: () => import("src/pages/demo/elements/FilteringElements.vue"),
    },
    {
      path: "health-indicator",
      name: DemoNamedPath.HEALTH_INDICATOR,
      component: () => import("src/pages/demo/elements/HealthIndicator.vue"),
    },
    {
      path: "images",
      name: DemoNamedPath.IMAGE_GALLERY,
      component: () => import("src/pages/demo/elements/ImageElements.vue"),
    },
    {
      path: "charts",
      name: DemoNamedPath.CHARTS,
      component: () => import("src/pages/demo/elements/ChartElements.vue"),
    },
    {
      path: "tooltips",
      name: DemoNamedPath.TOOLTIPS,
      component: () => import("src/pages/demo/elements/TooltipElements.vue"),
    },
  ],
}

export default routes
